// 后台互动小说三个命名空间的葡萄牙文文案；key 结构与 en 完全一致（test/i18n.test.js 校验）。
export const novelPt = {
  novelPacks: {
    title: 'Obras de romance interativo',
    filters: { status: 'Status', allStatuses: 'Todos os status', search: 'Palavra-chave', searchPlaceholder: 'Título, slug ou e-mail do criador', apply: 'Buscar' },
    status: { draft: 'Rascunho', published: 'Publicada', unpublished: 'Despublicada', archived: 'Arquivada' },
    validation: { valid: 'Válida', invalid: 'Com erros' },
    listedInvalid: 'Novas partidas vão falhar',
    listedInvalidHint: 'Esta obra publicada não passa mais na verificação de conteúdo, então jogadores que iniciarem uma nova partida receberão um erro.',
    table: { title: 'Obra', owner: 'Criador', latestVersion: 'Versão mais recente', status: 'Status', validation: 'Verificação de conteúdo', featured: 'Destaque', updatedAt: 'Atualizada' },
    notFeatured: 'Sem destaque',
    noVersion: 'Ainda sem versão',
    emptyTitle: 'Nenhuma obra de romance corresponde aos filtros atuais.',
    actions: { preview: 'Visualizar', publish: 'Publicar', unpublish: 'Despublicar', featured: 'Ordem de destaque' },
    publishConfirm: 'Publicar “{title}”? Os jogadores a verão na estante e poderão iniciar novas partidas imediatamente.',
    blocked: { invalid: 'Não passa na verificação de conteúdo, não pode ser publicada', archived: 'Arquivada, não pode ser publicada' },
    unpublishConfirm: 'Despublicar esta obra? Novos jogadores deixarão de vê-la na estante; as partidas em andamento podem continuar.',
    toast: {
      published: '“{title}” publicada.',
      unpublished: '“{title}” despublicada.',
      featuredSet: 'Ordem de destaque de “{title}” salva.',
      featuredCleared: '“{title}” não está mais em destaque.',
    },
    featuredForm: {
      title: 'Ordem de destaque',
      rank: 'Ordem de destaque',
      hint: 'Um número inteiro, 0 ou maior. Números menores aparecem primeiro na estante. Deixe em branco para tirar a obra dos destaques.',
      clear: 'Remover destaque',
      save: 'Salvar',
      invalid: 'Informe um número inteiro, 0 ou maior.',
    },
    detail: {
      title: 'Detalhes da obra',
      owner: 'Criador',
      language: 'Idioma',
      status: 'Status',
      currentVersion: 'Versão atual',
      validation: 'Verificação de conteúdo',
      listedAt: 'Última publicação',
      contentHash: 'Hash do conteúdo',
      createdAt: 'Criada',
      updatedAt: 'Atualizada',
      versions: 'Versões',
      noVersions: 'Esta obra ainda não tem versões.',
      assets: 'Recursos',
      noAssets: 'Nenhum recurso enviado.',
      openingCg: { title: 'CG de abertura', loadVersion: 'Carregar versão publicada', assetKind: 'Tipo de recurso', video: 'Vídeo MP4', poster: 'Pôster JPG', captions: 'Legendas VTT', file: 'Arquivo', upload: 'Enviar recurso' },
      close: 'Fechar',
      cover: 'Capa',
      teaser: 'Resumo na estante',
      characters: 'Personagens',
      playerRole: 'Jogador',
      opening: 'Texto de abertura',
      empty: 'Nenhum',
      openStudio: 'Abrir no Studio',
      openStudioHint: 'O Studio só abre uma obra para o criador dela.',
      openPlayer: 'Ver no site dos jogadores',
      versionColumns: { version: 'Versão', note: 'Nota', validation: 'Verificação de conteúdo', publishedAt: 'Publicada', hash: 'Hash do pacote' },
      assetKinds: { cover: 'Capa', location: 'Local', state_image: 'Imagem de estado', item: 'Item' },
    },
    release: {
      title: 'Publicar em produção',
      hint: 'Envia ao Main uma versão que o criador gerou no Stage. O Main cria ou atualiza a obra pelo slug, torna essa versão o conteúdo atual e a publica; as imagens são copiadas por chave de objeto. Partidas, jogadores e registros contábeis nunca são copiados.',
      refresh: 'Atualizar',
      stage: 'Stage',
      main: 'Main (produção)',
      selectedVersion: 'Versão selecionada',
      versionNote: 'Nota da versão',
      cutAt: 'Criada em',
      connection: { connected: 'Conectado', not_configured: 'Não configurado', unreachable: 'Falha na conexão' },
      connectionHelp: { not_configured: 'Configure SCENARIO_RELEASE_TARGET_URL e SCENARIO_RELEASE_TOKEN no Stage (o mesmo token no Main) e reinicie a API.', unreachable: 'O Stage não conseguiu acessar o Main. Verifique a URL de destino, o token compartilhado e os logs da API nos dois lados.' },
      mainVersion: 'Versão atual no Main',
      releasedAt: 'Última publicação',
      targetUrl: 'Destino',
      notOnMain: 'Ainda não está no Main',
      noVersions: 'O criador ainda não gerou nenhuma versão. As versões são geradas no Studio.',
      versionLabel: 'Versão a publicar',
      noNote: 'Sem nota',
      invalidVersion: 'Esta versão não passa mais na verificação de conteúdo, então o Main a rejeitaria.',
      sameVersion: 'O Main já usa esta versão. Publicar de novo sincroniza novamente o conteúdo e as imagens.',
      adminRequired: 'Somente administradores podem publicar. Operadores podem ver o status e os registros.',
      publish: 'Publicar em produção',
      confirmTitle: 'Publicar em produção?',
      confirmBody: 'O Main tornará a {version} de “{title}” o conteúdo atual e a publicará imediatamente. Imagens que já existem no Main com o mesmo hash são reutilizadas.',
      noUserData: 'Partidas, jogadores e registros contábeis não são copiados.',
      progress: 'Publicando… mantenha esta janela aberta até terminar.',
      confirm: 'Publicar',
      successTitle: 'Publicada em produção',
      successSummary: '{version} está ativa no Main · {copied} enviadas, {reused} reutilizadas · {size} enviados',
      historyTitle: 'Registros de publicação',
      historyEmpty: 'Nenhuma publicação ainda.',
      operator: 'Operador',
      startedAt: 'Início',
      transfer: 'Imagens (enviadas / reutilizadas)',
      releaseId: 'ID de publicação',
      slugTaken: 'O Main já tem uma obra com o slug “{slug}” criada por um criador do Main. O canal de publicação não pode sobrescrevê-la, então a publicação está desativada.',
      reasonCodes: {
        FORBIDDEN: 'O Main recusou o token compartilhado de publicação. SCENARIO_RELEASE_TOKEN precisa ser igual no Stage e no Main.',
        NOT_FOUND: 'O Main não tem a interface ou o registro de publicação de romances. Confira se o Main roda a mesma versão do código.',
      },
      logs: {
        locked: 'Versão {version} do Stage fixada com {assets} objetos',
        received: 'Versão {version} do Stage recebida com {assets} objetos',
        sending: 'Enviando o pacote de publicação para produção',
        syncing: 'Verificando e sincronizando imagens',
        writing: 'Imagens sincronizadas ({copied} enviadas, {reused} reutilizadas); gravando a obra e a versão',
        switched: 'Produção mudou para {version}',
        failed: 'Falhou: {reason}',
      },
      stale: {
        hint: 'Esta publicação está parada há mais de 30 minutos; a API provavelmente reiniciou durante a publicação. Ela bloqueia novas publicações desta obra até você encerrá-la como falha.',
        hintOperator: 'Esta publicação está parada há mais de 30 minutos e bloqueia novas publicações desta obra. Peça a um administrador para encerrá-la.',
        finish: 'Encerrar como falha',
      },
      status: { prepared: 'Preparada', transferring: 'Transferindo', applying: 'Aplicando', succeeded: 'Concluída', failed: 'Com falha' },
    },
    pager: { prev: 'Anterior', next: 'Próxima', pageSize: 'Por página', summary: '{total} obras · página {page} de {pages}' },
  },
  novelRuns: {
    title: 'Partidas de romance',
    list: {
      filters: { email: 'E-mail do jogador', emailPlaceholder: 'Buscar por e-mail', pack: 'Obra', packSearch: 'Todas as obras (digite para buscar título, slug ou e-mail do criador)', packSearching: 'Buscando…', packEmpty: 'Nenhuma obra correspondente', packClear: 'Limpar filtro de obra', failedOnly: 'Só partidas com tarefas com falha', apply: 'Buscar' },
      table: { player: 'Jogador', pack: 'Obra', status: 'Status', turns: 'Turnos', jobs: 'Tarefas em segundo plano', failedJobs: 'Tarefas com falha', lastPlayed: 'Última jogada', actions: 'Ações' },
      statuses: { active: 'Ativa', archived: 'Arquivada' },
      jobsPending: 'Pendentes',
      jobsIdle: 'Nenhuma',
      unknownUser: 'Jogador desconhecido',
      empty: 'Nenhuma partida corresponde a estes filtros',
      audit: 'Auditar',
      filterByPack: 'Mostrar só as partidas desta obra',
      pager: { prev: 'Anterior', next: 'Próxima', pageSize: 'Por página', summary: '{total} partidas · página {page} de {pages}' },
    },
    audit: {
      back: 'Partidas',
      refresh: 'Atualizar',
      empty: 'Nenhum',
      copy: 'Copiar',
      copied: 'Copiado',
      copyFailed: 'Falha ao copiar: {message}',
      copyId: 'Copiar {id}',
      points: '{points} pts',
      separator: ', ',
      spoilerNotice: 'Contém spoilers, visão do autor: configurações ocultas, conhecimento dos personagens, prompts reais e saída do modelo. Não compartilhe com jogadores.',
      tabs: { overview: 'Visão geral', characters: 'Personagens', timeline: 'Linha do tempo', director: 'Diretor', story: 'História', calls: 'Chamadas', drama: 'Avatar digital', raw: 'Dados brutos' },
      bar: {
        turns: 'Turno {count}',
        jobsPending: 'Tarefas pendentes',
        jobsIdle: 'Sem tarefas',
        writer: 'Escritor {model}',
        writerTitle: 'Escritor desta partida: {performer}; modelo real mais recente: {model}',
        points: '{points} pts no total',
        refreshTitle: 'Última atualização: {time}. Somente leitura; abrir esta página não chama nenhum modelo.',
        retryFailed: 'Tentar de novo as tarefas com falha ({count})',
      },
      overview: { runInfo: 'Dados da partida', player: 'Jogador', work: 'Obra', packageHash: 'Hash do conteúdo', created: 'Criada', lastPlayed: 'Última jogada', branch: 'Ramo' },
      branch: { active: 'ativo', candidate: 'candidato', option: '{id} · {state} · {turns} turnos' },
      scene: {
        title: 'Cena atual',
        people: 'Presentes',
        storyTime: 'Tempo da história',
        items: 'Itens aqui',
        recording: {
          pending: 'O texto está salvo; a cena e o conhecimento dos personagens estão sendo atualizados em segundo plano.',
          failed: 'O texto está salvo, mas o registro em segundo plano falhou; tente de novo pela lista de tarefas em Chamadas.',
        },
      },
      request: {
        title: 'Solicitação mais recente',
        input: 'Entrada',
        status: 'Status',
        elapsed: 'Duração',
        cost: 'Custo',
        stage: 'Etapa',
        model: 'Modelo',
        unrecorded: 'Nenhum registro de etapa do modelo foi salvo para esta solicitação; nada é reconstruído a partir de templates.',
      },
      roles: { performer: 'Escritor', structured: 'Estruturado' },
      time: {
        day: 'Dia {day}',
        phases: { morning: 'Manhã', afternoon: 'Tarde', evening: 'Anoitecer', night: 'Noite' },
      },
      requestStatuses: { generating: 'Gerando', committed: 'Confirmada', failed: 'Com falha', cancelled: 'Cancelada' },
      stageStatuses: { started: 'Iniciada', completed: 'Concluída', failed: 'Com falha' },
      turns: {
        turn: 'Turno {seq}',
        modes: { mixed: 'Fala e ação', speech: 'Fala', action: 'Ação', continue: 'Continuar' },
        recordingStates: { pending: 'Registro pendente', completed: 'Registrado', failed: 'Falha no registro' },
      },
      characters: {
        list: 'Personagens',
        openCount: '{count} em aberto',
        appearance: 'Aparência',
        identity: 'Identidade',
        initialGoal: 'Objetivo inicial',
        latestGoal: 'Objetivo mais recente',
        sections: { opening: 'Configuração inicial', later: 'Registros posteriores', witness: 'Testemunhos e observações', memory: 'Memória contínua' },
        facts: 'Fatos conhecidos',
        relations: 'Relações',
        portrayal: 'Personalidade e voz',
        personality: 'Personalidade',
        speechStyle: 'Voz',
        cues: 'Pistas de atuação',
        examples: 'Exemplos de voz (não são histórico)',
        attitude: 'Atitude',
        goals: 'Objetivos',
        threads: 'Pendências em aberto',
        thread: 'Pendência',
        witnessed: 'Trechos presenciados',
        witnessTurn: 'Turno',
        witnessText: 'Trecho',
        witnessBy: 'Presenciado por',
        witnessPending: 'Testemunhos aguardando o registro narrativo: turnos {turns}',
        witnessFailed: 'O registro narrativo falhou em {range}: {reason}',
        observations: 'Observações',
        memoryProgress: 'até o turno {count}',
      },
      timeline: {
        positions: 'Posições',
        placePeople: ': {people}',
        events: 'Eventos',
        audience: 'Presenciado por',
        moves: 'Movimentos',
        timeChange: 'Tempo da história',
        transfers: 'Transferências de itens',
        kinds: { move: 'Movimento', time: 'Tempo da história', transfer: 'Transferência de item', witness: 'Presenciado' },
        items: 'Itens',
        item: 'Item',
        holder: 'Portador',
        place: 'Local',
        unheld: 'Sem portador',
      },
      director: {
        on: 'Diretor ativado',
        off: 'Diretor desativado',
        unknown: 'Diretor não registrado',
        revision: 'Revisão {revision}',
        latest: 'Sugestão mais recente',
        directionStatus: 'Status',
        basis: 'Com base em',
        validThrough: 'Válida até',
        guidanceId: 'Sugestão',
        deliveries: 'Entrega por turno',
        deliveriesHint: '“Repassada ao escritor” é julgado apenas pelo registro de injeção salvo; o texto não prova que o modelo a adotou.',
        turn: 'Turno',
        delivery: 'Entrega',
        passedWriter: 'Repassada ao escritor',
        reason: 'Motivo',
        yes: 'Sim',
        no: 'Não',
        notRecorded: 'Não registrado',
        hashPending: 'Verificando',
        hashFailed: 'Não é possível calcular',
        hashFailedHint: 'Este navegador não consegue calcular o hash de preferências (precisa de HTTPS ou localhost), então não se sabe se a sugestão pode ser usada.',
        statuses: {
          disabled: 'Desativado',
          pending: 'Preparando',
          ready: 'Pronta',
          unavailable: 'Sem sugestão',
          available: 'Disponível',
          expired: 'Expirada',
          not_ready: 'Não pronta',
          injected_direction: 'Injetada',
        },
        statusHints: {
          disabled: 'Desativado: sem chamada e sem injeção.',
          pending: 'Preparando a sugestão em segundo plano; o texto não espera.',
          ready: 'A direção está disponível.',
          unavailable: 'Nenhuma sugestão disponível.',
          available: 'Disponível para esta etapa.',
          expired: 'Mostrada só como referência; não é mais injetada.',
          not_ready: 'Não injetada: a sugestão não estava pronta.',
          injected_direction: 'Direção de etapa injetada.',
        },
        reasons: {
          director_disabled: 'Desativado: sem chamada e sem injeção.',
          guidance_pending: 'Preparando a sugestão em segundo plano; o texto não espera.',
          guidance_unavailable: 'Nenhuma sugestão disponível.',
          guidance_expired: 'Mostrada só como referência; não é mais injetada.',
          recording_pending: 'O registro do texto ainda está sendo preparado em segundo plano.',
          director_revision_changed: 'A revisão das configurações do Diretor mudou.',
          preferences_changed: 'As preferências fora da história mudaram.',
          phase_direction: 'A direção de etapa foi incluída.',
        },
      },
      preferences: {
        title: 'Preferências fora da história',
        kinds: { pace: 'Ritmo', focus: 'Personagem em foco', direction: 'Direção', expectation: 'Expectativa fora da história' },
        scopes: { branch: 'Esta partida', next_4_turns: 'Próximos quatro turnos' },
        sources: { explicit_ui: 'definida pelo jogador', explicit_ooc_expectation: 'escrita pelo jogador' },
        paces: { linger: 'Demorar-se', follow: 'Seguir o jogador', advance: 'Avançar' },
      },
      story: {
        title: 'Registro da história',
        turnCount: '{count} turnos',
        opening: 'Abertura',
        narrator: 'Narrador',
        playerInput: 'Entrada do jogador',
        channels: { narration: 'Narração', dialogue: 'Diálogo', action: 'Ação' },
        metadataPending: 'Aguardando registro',
        audience: 'Presenciado por: {names}',
        generating: 'Um turno está sendo gerado; o rascunho ao vivo só existe no processo de jogo e não aparece aqui.',
      },
      sources: {
        evidence: 'Evidências {count}',
        evidenceLabel: 'Fontes de evidência',
        missing: 'O texto da fonte não está salvo',
        range: 'Turnos {from}–{through}',
        turn: 'Turno {count}',
        kinds: { opening: 'Abertura', author_fact: 'Fato inicial do autor', event: 'Evento registrado', turn: 'Turno da história', unknown: 'Evidência salva' },
      },
      memoryKinds: {
        observed: 'Observado',
        reported: 'Relatado',
        belief: 'Crença',
        interpretation: 'Interpretação',
        correction: 'Correção de memória',
        conflict: 'Conflito de memória',
        record: 'Registro de memória',
      },
      calls: {
        title: 'Chamadas ao modelo',
        count: '{count} chamadas',
        totalCost: 'Custo total {cost}',
        failedCount: '{count} com falha',
        time: 'Hora',
        source: 'Origem',
        role: 'Papel',
        model: 'Modelo · provedor',
        status: 'Status',
        ttft: 'Primeiro token',
        duration: 'Duração',
        tokens: 'Tokens entrada / saída',
        cost: 'Custo',
        expand: 'Mostrar o corpo da solicitação e a saída',
        sourceRequest: 'Solicitação',
        sourceJob: 'Tarefa em segundo plano',
        sourceOther: 'Outro',
        statuses: { ok: 'OK', error: 'Erro', aborted: 'Interrompida' },
        callId: 'Chamada',
        authNotRecorded: 'cabeçalhos de autenticação e variáveis de ambiente nunca são registrados',
        requestBody: 'Corpo da solicitação',
        messageCount: '{count} mensagens',
        chars: '{count} caracteres',
        output: 'Saída',
        reasoning: 'Raciocínio',
        finishReason: 'Motivo de término',
        protocol: 'Protocolo',
        unavailable: 'Indisponível na auditoria da plataforma',
      },
      drama: {
        title: 'Atuações do avatar',
        hint: 'Uma atuação por turno; os pontos são reservados no início e devolvidos se falhar antes do primeiro quadro.',
        time: 'Início',
        person: 'Personagem e estado',
        duration: 'Duração',
        firstFrame: 'Primeiro quadro',
        result: 'Resultado',
        points: 'Pontos',
        refund: 'Reembolso',
        refunded: 'Reembolsado',
        refundedTotal: '{points} pts reembolsados',
        count: '{count} atuações',
        empty: 'Esta partida não tem atuações do avatar.',
        statuses: { starting: 'Conectando', live: 'Atuando', ended: 'Encerrada' },
        reasons: { completed: 'Concluída', cancelled_during_start: 'Cancelada ao iniciar', disconnected: 'Desconectada', start_failed: 'Falha ao iniciar', playback_failed: 'Falha na reprodução', hidden: 'Página oculta', switched_off: 'Desativada', unmounted: 'Saiu da página', turn_cancelled: 'Turno cancelado', replaced: 'Substituída por outra atuação', browser_disconnected: 'Conexão de controle perdida', expired: 'Limite de tempo atingido', interrupted: 'Interrompida por um reinício do servidor' },
      },
      jobs: {
        title: 'Tarefas em segundo plano',
        kind: 'Tipo',
        range: 'Turnos',
        status: 'Status',
        attempts: 'Tentativas',
        nextRetry: 'Próxima tentativa',
        error: 'Erro',
        retry: 'Tentar de novo',
        retried: '{count} tarefa(s) na fila para nova tentativa',
        trigger: 'Gatilho: {trigger}',
        completed: 'Concluída: {time}',
        kinds: { narrative_record: 'Registrar turno', memory: 'Memória', director: 'Diretor', suggestions: 'Sugestões' },
        triggers: { cadence: 'Rotina a cada quatro turnos', enabled: 'Diretor ativado', preference_changed: 'Preferências alteradas', forked: 'Ramo bifurcado' },
        statuses: { pending: 'Pendente', completed: 'Concluída', failed: 'Com falha', superseded: 'Substituída' },
      },
      requests: { title: 'Solicitações de turno', time: 'Início', turn: 'Turno', input: 'Entrada', status: 'Status', error: 'Erro', elapsed: 'Duração', points: 'Pontos', id: 'ID', diagnostics: 'Feedback de validação', diagnosticsCount: '{count} itens', diagnosticsExpand: 'Mostrar {count} itens de feedback de validação' },
      diagnostics: {
        raw: 'Saída do modelo · {count} caracteres',
        kinds: {
          narrative_format: 'Verificação de formato',
          narrative_preamble: 'Texto antes da história',
          narrative_tag_normalization: 'Normalização de tags',
          narrative_recording: 'Registro da história',
          narrative_continuity: 'Revisão de continuidade',
          memory_owner_failure: 'Falha na memória do personagem',
        },
      },
      errors: {
        unknown: 'Erro não classificado',
        internal_error: 'Erro interno do servidor',
        interrupted: 'Interrompido por uma reinicialização do serviço',
        cancelled: 'Cancelado',
        insufficient_balance: 'Saldo de pontos insuficiente',
        stale_turn: 'O jogo salvo mudou antes de este turno terminar',
        busy: 'Outra solicitação estava em andamento',
        run_archived: 'A partida está arquivada',
        invalid_data: 'Dados inválidos',
        content_filter: 'Bloqueado pelo filtro de conteúdo',
        model_output_limit: 'A saída do modelo atingiu o limite de tamanho',
        model_response_blocked: 'O modelo recusou ou a política de segurança bloqueou a resposta',
        incomplete_model_output: 'A saída do modelo ficou incompleta',
        model_not_configured: 'Nenhum modelo configurado para esta etapa',
        context_limit: 'O contexto excede o limite do modelo',
        invalid_structured_json: 'Não foi possível analisar a saída estruturada',
        invalid_narrative_format: 'O formato do texto narrativo é inválido',
        invalid_performance: 'A configuração de personagem ou cenário é inválida',
        invalid_performance_states: 'A saída de estado do escritor é inválida',
        missing_narrative_tags: 'Faltam marcações de falante no texto',
        invalid_speaker: 'Falante inválido',
        invalid_narrative_record: 'A saída do registro narrativo é inválida',
        narrative_recording_failed: 'O registro narrativo falhou',
        narrative_record_gap: 'Os turnos anteriores ainda não foram registrados',
        invalid_story_time: 'Tempo da história inválido',
        invalid_item_transfer: 'Transferência de item inválida',
        invalid_scene_location: 'Local da cena inválido',
        invalid_scene_path: 'Caminho de movimento inválido',
        source_conflict: 'As fontes de evidência se contradizem',
        memory_too_long: 'O resumo de memória está longo demais',
        memory_source_too_large: 'Material de origem demais para uma tarefa de memória',
        memory_context_limit: 'O contexto de memória excede o limite do modelo',
        memory_backlog_waiting: 'Aguardando tarefas de memória anteriores',
        invalid_correction: 'Correção de memória inválida',
        unsupported_correction: 'Correção de memória não suportada',
        invalid_player_suggestions: 'A saída de sugestões de resposta é inválida',
        invalid_preference: 'Preferência inválida',
        job_conflict: 'Tarefa em conflito',
        package_integrity_failed: 'O conteúdo da obra falhou na verificação de integridade',
      },
      raw: {
        title: 'Dados brutos',
        pack: 'Conteúdo da obra',
        snapshot: 'Snapshot completo',
        requests: 'Registros de solicitações',
        contextNote: 'context_records são snapshots do contexto em execução; só os corpos de solicitação na aba Chamadas são o que foi enviado ao modelo.',
      },
    },
  },
  novelErrors: {
    unknown: 'Erro não classificado',
    codes: {
      BAD_REQUEST: 'O servidor rejeitou a solicitação como inválida.',
      VALIDATION_ERROR: 'O servidor rejeitou a solicitação como inválida.',
      UNAUTHORIZED: 'Sua sessão expirou. Entre novamente.',
      FORBIDDEN: 'Esta conta não tem permissão para fazer isso.',
      NOT_FOUND: 'Isso não existe mais.',
      CONFLICT: 'Os dados mudaram nesse meio-tempo. Atualize e tente de novo.',
      NOVEL_RELEASE_NOT_CONFIGURED: 'O Stage não tem o destino de publicação em produção configurado.',
      NOVEL_RELEASE_TARGET_UNREACHABLE: 'O Stage não conseguiu acessar a produção. Veja o registro de publicação abaixo.',
      NOVEL_RELEASE_TARGET_REJECTED: 'A produção rejeitou a publicação. Veja o motivo no registro abaixo.',
      NOVEL_RELEASE_FAILED: 'A produção não conseguiu aplicar a publicação. A causa está no detalhe do registro.',
      NOVEL_RELEASE_STORAGE_RESIDUE: 'O conteúdo ainda referencia endereços de armazenamento que não podem ser reescritos (domínio OSS antigo, http ou parâmetros de consulta). Corrija os endereços das imagens no Studio, crie uma nova versão e publique de novo.',
      NOVEL_RELEASE_STALE: 'A publicação travou (a API reiniciou durante a publicação) e um administrador a encerrou como falha.',
      NOVEL_RELEASE_IN_PROGRESS: 'A produção ainda está aplicando esta publicação. O registro continua em andamento e será atualizado quando o recibo for confirmado; atualize mais tarde.',
      NOVEL_RELEASE_ALREADY_FAILED: 'Este ID de publicação já falhou. Inicie uma nova publicação.',
      NOVEL_RELEASE_CHECKSUM_MISMATCH: 'A produção detectou que o checksum do pacote de publicação não confere.',
      NOVEL_RELEASE_BUNDLE_INVALID: 'A produção detectou que a lista de objetos do pacote não confere com o conteúdo.',
      RATE_LIMITED: 'Solicitações demais. Tente de novo em instantes.',
      INTERNAL_ERROR: 'Erro no servidor. Tente de novo mais tarde.',
      HTTP_ERROR: 'A solicitação falhou.',
    },
    reasons: {
      release_in_progress: 'Esta obra já tem uma publicação em andamento. Aguarde terminar.',
      release_id_conflict: 'Este ID de publicação já pertence a outro conteúdo.',
      release_slug_taken: 'O Main já tem uma obra com este slug criada por um criador do Main, então a publicação não pode sobrescrevê-la.',
      release_version_conflict: 'O Main já tem este número de versão com conteúdo diferente. Crie uma nova versão no Studio e publique-a.',
      release_content_invalid: 'Esta versão não passa na verificação de conteúdo do Main, então o Main não a aplicou.',
      release_pack_archived: 'A obra no Main está arquivada, então não é possível publicar nela.',
      release_not_stale: 'Esta publicação ainda está avançando. Só é possível encerrar publicações paradas há mais de 30 minutos.',
      release_invalid_transition: 'Este registro de publicação já terminou. Atualize para ver o status.',
      release_not_found: 'Este registro de publicação não existe mais.',
      pack_not_found: 'Esta obra não existe mais.',
      pack_content_invalid: 'O conteúdo não passa na verificação, então a obra não pode ser publicada.',
      invalid_status_transition: 'O status atual desta obra não permite esta ação. Atualize e tente de novo.',
      invalid_featured_rank: 'A ordem de destaque deve ser um número inteiro, 0 ou maior.',
      run_not_found: 'Esta partida não existe mais.',
      run_archived: 'Esta partida está arquivada, então as tarefas dela não podem ser tentadas de novo.',
      adopt_forbidden: 'Só o dono da partida de origem pode adotar um lado.',
      stale_comparison: 'A partida de origem avançou desde o início da comparação. Recomece a comparação.',
      already_adopted: 'Um lado desta comparação já foi adotado.',
      nothing_to_adopt: 'Este lado ainda não tem turnos novos para adotar.',
      comparison_not_found: 'Esta comparação não existe mais (são removidas após 24 horas).',
      invalid_comparison_source: 'Uma partida de comparação não pode ser a origem de outra comparação.',
      model_not_configured: 'O modelo de escrita escolhido não está configurado.',
      invalid_performer: 'O modelo escolhido não está na cadeia de escrita.',
      invalid_director_comparison: 'Para comparar só o diretor, os dois lados precisam do mesmo modelo.',
      narrative_required: 'Esta obra não tem texto, então não pode ser comparada.',
      busy: 'A partida está gerando. Tente de novo quando terminar.',
    },
  },
}
